import { Placeholder, PlaceholderLine, PlaceholderLines } from '@/src/elements/placeholder'

export const PublicationContentPlaceholder = () => (
  <Placeholder noBackground className="flex-col gap-4 px-0 py-0">
    <PlaceholderLine length="custom" className="my-5 w-3/4" />
    <PlaceholderLines size="sm" nb={5} />
    <PlaceholderLine size="sm" length="half" />
    <PlaceholderLine length="custom" className="my-5 w-48" />
    <PlaceholderLines size="sm" nb={3} />
    <PlaceholderLine size="sm" length="half" />
    <PlaceholderLine length="custom" className="my-5 w-60" />
    <PlaceholderLines size="sm" nb={8} />
    <PlaceholderLine size="sm" length="half" />
  </Placeholder>
)
